<template>
  <InnerView>
    <template #header>
      <div class="space-y-2">
        <h1
          class="flex items-center font-bold text-primary-contrast pl-1 tracking-wide transition-all text-3xl"
        >
          {{ $t('notifications.title') }}
        </h1>
        <notifications-menu-view />
      </div>
    </template>
    <notifications-list-view @go-to-content="handleGoToContent" />
  </InnerView>
</template>

<script setup lang="ts">
import InnerView from '@commons/components/Layout/InnerView.vue'

const { redirectUrl } = useExternalRedirection()
const { goToEntity } = useEntities()

const handleGoToContent = (content: any) => {
  if (content.type === 'Task') {
    const url = redirectUrl(`/tasks/board?modalTaskId=${content.id}`)

    if (!url) return
    window.open(url, '_blank')
  } else if (content.type === 'PublishedModule') {
    const url = redirectUrl(`/desk/academy/modules/${content.lang}/${content.id}`)

    if (!url) return
    window.open(url, '_blank')
  } else if (content.type === 'Module') {
    const url = redirectUrl(`/academy/modules/${content.lang}/${content.id}`)

    if (!url) return
    window.open(url, '_blank')
  } else if (content.type === 'Program') {
    const url = redirectUrl(`/desk/academy/programs/${content.lang}/${content.id}`)

    if (!url) return
    window.open(url, '_blank')
  } else if (content.type === 'Workshop') {
    const url = redirectUrl(`/desk/academy/modules?workshopId=${content.id}`)

    if (!url) return
    window.open(url, '_blank')
  } else {
    showEntity(content)
  }
}
</script>
